import React, { Component } from 'react';
import './../../css/table.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrash, faPlus, faEdit } from '@fortawesome/free-solid-svg-icons';
import axios from 'axios';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import { Link } from 'react-router-dom';
import Spinner from 'react-bootstrap/Spinner';
import 'bootstrap/dist/css/bootstrap.min.css';

const MySwal = withReactContent(Swal);

export default class CategoryJobOpportunityTable extends Component {
    constructor() {
        super();
        this.state = {
            categories: [],
            search: '',
            loading: true
        };
    }

    componentDidMount() {
        this.getCategories();
    }

    getCategories() {
        axios
            .get('https://arianaapp.arianaapply.com/panel/show-cat-job-opportunity-all')
            .then((response) => {
                this.setState({
                    categories: response.data.data || [],
                    loading: false
                });
            })
            .catch((err) => {
                console.log(err);
                this.setState({ loading: false });
                MySwal.fire({
                    title: 'خطا در دریافت اطلاعات',
                    icon: 'error',
                });
            });
    }

    deleteHandler(id) {
        Swal.fire({
            title: 'آیا مطمئن هستید؟',
            text: 'این دسته‌بندی حذف خواهد شد',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'بله، حذف شود',
            cancelButtonText: 'انصراف'
        }).then((result) => {
            if (result.isConfirmed) {
                axios
                    .get(`https://arianaapp.arianaapply.com/panel/delete-cat-job-opportunity/${id}`)
                    .then((res) => {
                        Swal.fire({
                            title: 'با موفقیت حذف شد',
                            icon: 'success',
                        }).then(() => {
                            this.getCategories();
                        });
                    })
                    .catch((err) => {
                        if (err.response && err.response.status === 409) {
                            Swal.fire({
                                title: 'هشدار',
                                text: err.response.data.message,
                                icon: 'warning',
                                showCancelButton: true,
                                confirmButtonText: 'حذف اجباری',
                                cancelButtonText: 'انصراف'
                            }).then((forceResult) => {
                                if (forceResult.isConfirmed) {
                                    axios
                                        .get(`https://arianaapp.arianaapply.com/panel/delete-cat-job-opportunity/${id}?force=true`)
                                        .then(() => {
                                            Swal.fire({
                                                title: 'با موفقیت حذف شد',
                                                icon: 'success',
                                            }).then(() => {
                                                this.getCategories();
                                            });
                                        })
                                        .catch(() => {
                                            Swal.fire({
                                                title: 'خطا در حذف',
                                                icon: 'error',
                                            });
                                        });
                                }
                            });
                        } else {
                            Swal.fire({
                                title: 'خطا در حذف',
                                icon: 'error',
                            });
                        }
                    });
            }
        });
    }

    render() {
        const { categories, search, loading } = this.state;

        if (loading) {
            return (
                <div className='index' style={{ textAlign: 'center', marginTop: '3rem' }}>
                    <Spinner animation='border' variant='primary' />
                </div>
            );
        }

        return (
            <div className='index'>
                <div className='table'>
                    {/* نوار جستجو و دکمه افزودن - داخل table */}
                    <div style={{ width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center', margin: '1rem 0', gap: '15px', flexWrap: 'wrap' }}>
                        <input
                            className='search-input'
                            type='search'
                            name='search'
                            value={search}
                            placeholder='جستجو در دسته‌بندی‌ها...'
                            onChange={(e) => this.setState({ search: e.target.value })}
                        />
                        <Link to='/category-job-add'>
                            <button className='success' style={{ width: 'auto', padding: '0 15px', height: '35px' }}>
                                <FontAwesomeIcon icon={faPlus} /> افزودن دسته‌بندی
                            </button>
                        </Link>
                    </div>

                    <table>
                        <thead>
                            <tr>
                                <td style={{ width: '70px' }}>#</td>
                                <td>نام انگلیسی (category)</td>
                                <td>نام فارسی (category_fa)</td>
                                <td style={{ width: '100px' }}>عملیات</td>
                            </tr>
                        </thead>
                        <tbody>
                            {categories
                                .filter((item) =>
                                    (item.category && item.category.toLowerCase().includes(search.toLowerCase())) ||
                                    (item.category_fa && item.category_fa.includes(search))
                                )
                                .map((item, i) => (
                                    <tr key={item._id}>
                                        <td>{i + 1}</td>
                                        <td>{item.category}</td>
                                        <td>{item.category_fa}</td>
                                        <td>
                                            <div className='d-flex'>
                                                <Link to={`/category-job-edit/${item._id}`}>
                                                    <button className='success'>
                                                        <FontAwesomeIcon icon={faEdit} />
                                                    </button>
                                                </Link>
                                                <button
                                                    className='danger'
                                                    onClick={() => this.deleteHandler(item._id)}
                                                    style={{ marginRight: '5px' }}
                                                >
                                                    <FontAwesomeIcon icon={faTrash} />
                                                </button>
                                            </div>
                                        </td>
                                    </tr>
                                ))}
                        </tbody>
                    </table>

                    {categories.length === 0 && (
                        <div style={{ textAlign: 'center', padding: '2rem' }}>
                            هیچ دسته‌بندی‌ای وجود ندارد
                        </div>
                    )}
                </div>
            </div>
        );
    }
}